/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kindle_Listen_To_PageInputs */

const en_kindle_listen_to_page = /** @type {(inputs: Kindle_Listen_To_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen to this page`)
};

const es_kindle_listen_to_page = /** @type {(inputs: Kindle_Listen_To_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escuchar esta página`)
};

/**
* | output |
* | --- |
* | "Listen to this page" |
*
* @param {Kindle_Listen_To_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const kindle_listen_to_page = /** @type {((inputs?: Kindle_Listen_To_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kindle_Listen_To_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_kindle_listen_to_page(inputs)
	return en_kindle_listen_to_page(inputs)
});